module.exports = __webpack_public_path__ + "img/currents-compare.6eda1d9.png";